<template>
  <div>
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <appl-menu-icon
          :propsParam="{
            applCd: 22,
            gntGubunCd: 11,
          }"
        />
        대체휴가를 선택해주세요
      </v-col>
      <v-col cols="12" class="pt-0 px-6 title-desc">
        <div class="alter-info">
          {{ alterInfoMsg }}
        </div>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="12" class="text-center calendar-title">
        대체휴가 날짜선택
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="12" class="text-center pa-0 pt-5">
        <v-date-picker
          v-model="dates"
          range
          full-width
          no-title
          color="blue"
          @input="dateChanged"
          :weekday-format="getDay"
          :month-format="getMonth"
          :header-date-format="getHeaderDate"
        />
      </v-col>
    </v-row>
    <v-row class="ma-0 bb-line">
      <v-col cols="12" class="py-5 px-6">
        <div class="borderLine-wrap" @click="bottomSelect = !bottomSelect">
          <span class="borderLine-title">휴가 종류</span>
          <v-btn elevation="0" text fab width="24" height="24" class="ml-auto"
            ><v-icon size="24" color="#9ca3ab">mdi-chevron-right</v-icon></v-btn
          >
        </div>
        <div class="py-3">
          <span>{{ alterCodeObj.codeNm || '휴가 종류를 선택해주세요.' }}</span>
        </div>
      </v-col>
    </v-row>
<!--    <bottom-select-->
<!--      :flag="bottomSelect"-->
<!--      :title="selectTitle"-->
<!--      :list="GET_GNT_CD_LIST"-->
<!--      @selectItem="selectItem"-->
<!--    />-->
    <v-bottom-sheet v-if="bottomSelect" v-model="bottomSelect">
      <bottom-sheet :title="selectTitle" :default="selected" :items="GET_GNT_CD_LIST" @selectItem="selectItem"></bottom-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
import ApplMenuIcon from '@/components/application/form/ApplMenuIcon.vue';
import BottomSelect from '@/components/application/form/BottomSelect.vue';

import routerNames from '@/const/routerConstants';
import { checkOtWorkAlter } from '@/api/application';
import { getDay, getMonth, getHeaderDate } from '@/utils/common/datePicker.js';
import { mapGetters, mapMutations } from 'vuex';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import BottomSheet from "@/components/application/form/BottomSheet.vue";
dayjs.locale('ko');

export default {
  data: () => ({
    dates: [],
    bottomSelect: false,
    selectTitle: '대체휴가 종류',
    alterCodeObj: {},
    selected : ''
  }),
  computed: {
    ...mapGetters('ELA', [
      'GET_REQUEST_HOUR',
      'GET_OTWORK_APPL_GUBUN',
      'GET_ALTVAC_APPL_STATUS',
      'GET_OTWORK_PARAM',
    ]),
    ...mapGetters('CODE', ['GET_GNT_CD_LIST']),
    // 대체휴가 안내 메세지
    alterInfoMsg() {
      var alterMsg = '';
      var alterNm = '대체휴일';
      // console.log(alterNm);
      var status = this.GET_ALTVAC_APPL_STATUS;

      //사전일 때는 대체휴가가 자동신청 되지 않음
      if (this.GET_OTWORK_APPL_GUBUN === 'B') status = 'N';

      switch (status) {
        case 'N':
        case '11':
          alterMsg =
            '* 대체휴가는 [대체휴가신청] 메뉴에서 별도로 신청 해주세요.';
          alterNm = '대체휴일(예정)';
          break;
        case '21':
          alterMsg =
            '* 연장근무신청 처리완료 시 대체휴가가 자동신청 됩니다.(결재처리 필요)';
          alterNm = '대체휴일(확정)';
          break;
        case '99':
          alterMsg =
            '* 연장근무신청 처리완료 시 대체휴가가 자동신청 후 완료처리 됩니다. (신청 조건이 맞지 않을 경우 신청되지 않습니다.)';
          alterNm = '대체휴일(확정)';
          break;
      }
      return alterMsg;
    },
    fetchDate() {
      return this.dates[0].replaceAll('-', '');
    },
  },

  methods: {
    ...mapMutations('ELA', [
      'SET_ALTER_YMD',
      'SET_ALTER_GNT_CD',
      'SET_ALTER_GNT_NM',
      'SET_ALTER_WEEK',
      'SET_OTWORK_PARAM',
    ]),

    dateChanged() {
      const date = this.dates[0];
      this.dates[1] = date;
      this.SET_ALTER_YMD(this.fetchDate);
      this.SET_ALTER_WEEK(dayjs(date).format('ddd'));
      this.nextStep();
    },

    selectItem(data) {
      this.alterCodeObj = data;
      this.SET_ALTER_GNT_CD(data.code);
      this.SET_ALTER_GNT_NM(data.codeNm);
      this.bottomSelect = !this.bottomSelect;
      this.selected = data.code;
      this.nextStep();
    },

    // 대체휴가 유효성 검사
    async validAlterData() {
      let returnData = false;
      const stdApplyHour = Number(this.alterCodeObj.stdApplyHour);

      // 근태명 신청 기준시간 비교
      if (this.GET_REQUEST_HOUR < stdApplyHour) {
        alert(
          `연장근무시간(${this.GET_REQUEST_HOUR}시간)이 근태적용시간(${stdApplyHour}시간)보다 부족하여 신청 할 수 없습니다. 연장근무 시간을 다시 선택해주세요.`,
        );
        this.resetAltCode();
        return returnData;
      }

      try {
        this.SET_OTWORK_PARAM();
        const response = await checkOtWorkAlter(this.GET_OTWORK_PARAM);
        const data = response.data.data;

        if (data.msg !== 'OK') {
          alert(data.msg);
          this.resetDate();
          return returnData;
        }

        // 대체휴가 신청가능일자 체크
        if (this.fetchDate > data.dedlineYmd) {
          const formatDeadlineDay = dayjs(data.dedlineYmd).format('YYYY-MM-DD');
          alert(
            `대체휴일은 근무일로부터${data.dedlineDay}일 이내에 사용 해야 합니다.\n(사용기한 ${formatDeadlineDay} 까지)`,
          );

          this.resetDate();
          return returnData;
        }

        return !returnData;
      } catch (error) {
        console.log(error);
      }
    },

    async nextStep() {
      try {
        if (this.dates.length > 0 && this.alterCodeObj.code !== undefined) {
          const validateResult = await this.validAlterData();
          if (!validateResult) return false;

          this.$router.push(routerNames.ExtraOptions);
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 날짜만 리셋
    resetDate() {
      this.dates = [];
      this.SET_ALTER_YMD('');
      this.SET_ALTER_WEEK('');
    },

    // 대체휴가 코드만 리셋
    resetAltCode() {
      this.SET_ALTER_GNT_CD('');
      this.alterCodeObj = {};
    },

    getDay,
    getMonth,
    getHeaderDate,
  },

  components: {
    BottomSheet,
    ApplMenuIcon,
    BottomSelect,
  },
};
</script>

<style scoped>
.title-desc .alter-info {
  color: #21bf54;
  font-size: 12px;
  font-weight: 500;
}
</style>
